import * as mobx from 'mobx'
import PT from 'prop-types'
import { Observable as O } from 'rxjs'
import logger from '@vimcar/shared-utils/logger'

import i18n from '#utils/i18n'

const tp = i18n.prefix('components.CreateBooking')

const mkStore = (
  { initializer, registerObservable },
  _,
  { users }
) => initializer(
  () =>
    O.combineLatest(
      users.self.preferences.get(),
      users.self.notifications.fetch()
    ),
  (vm) => mobx.extendObservable(vm, {
    handleRequest: (o$) => {
      vm.error = null

      registerObservable(
        o$
          .catch(mobx.action((err) => {
            logger.error(err)
            vm.error = tp('unknown-error')
            return O.empty()
          }))
      )
    },
    updateUserPreferences: mobx.action(
      (newPreferences) =>
        vm.handleRequest(users.self.preferences.set(newPreferences))
    ),
  })
)

mkStore.contextTypes = {
  users: PT.object,
}

export default mkStore
